import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import request from '../../../utils/request';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';
import { orderStatus } from '../../../utils/constant';
import SendContractToModal from './sendContractToModal';

const SendContract = ({ orderData, fetchOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { sendContract }
  } = localizedStrings;

  const [contractRecipient, setContractRecipient] = useState({
    to: '',
    cc: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const setRecipient = () => {
    const { id } = orderData;
    const body = {
      contractEmail: contractRecipient.to,
      contractEmailCC: contractRecipient.cc,
      status: orderStatus.contractSent
    };
    request.put(`/orders/${id}`, body).then(() => {
      setIsModalOpen(false);
      window.location.reload();
      fetchOrders();
    });
  };

  useEffect(() => {
    const { email_companyAdmin: companyAdminEmail } = orderData;
    setContractRecipient({
      ...contractRecipient,
      to: companyAdminEmail
    });
  }, [orderData]);

  return (
    <>
      <Button className="action-button" onClick={() => setIsModalOpen(true)}>
        {sendContract}
      </Button>
      {isModalOpen && (
        <SendContractToModal
          contractRecipient={contractRecipient}
          setContractRecipient={setContractRecipient}
          setRecipient={setRecipient}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

SendContract.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default SendContract;
